module.exports = __webpack_public_path__ + "static/media/phone.b3b007bb.svg";